<template>

  <v-container
    v-if="transaction && transaction_types && transaction_methods && currencies && invoices"
    :style="{width: '100%', maxWidth: '960px'}"
    ref="parent"
    fluid
  >

    <v-card outlined class="ma-2" style="margin-bottom: 58px !important;">
      <v-card-title>Tranzacție</v-card-title>

      <v-divider class="mx-4"/>

      <v-card-text>

        <v-row no-gutters>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Detalii</div>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="transaction.reference_number" label="Referință" class="ma-1" outlined dense hide-details/>
          </v-col>

          <v-col cols="12" md="6">
            <v-menu v-model="menu_date" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="transaction.date" v-on="on" label="Dată" class="ma-1" readonly outlined dense hide-details/>
              </template>
              <v-date-picker v-model="transaction.date" @input="menu_date = false"/>
            </v-menu>
          </v-col>

          <v-col cols="12" md="6">
            <v-select v-model="transaction.type" :items="transaction_types" label="Tip" class="ma-1" outlined dense hide-details/>
          </v-col>

          <v-col cols="12" md="6">
            <v-select v-model="transaction.method" :items="transaction_methods" label="Metodă" class="ma-1" outlined dense hide-details/>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="transaction.amount" :suffix="transaction.currency" label="Valoare" class="ma-1" outlined dense hide-details/>
          </v-col>

          <v-col cols="12" md="4">
            <v-select v-model="transaction.currency" :items="currencies" label="Valută" item-text="value" class="ma-1" outlined dense hide-details/>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="transaction.exchange_rate" label="Rată de schimb" class="ma-1" type="number" outlined dense hide-details/>
          </v-col>

          <v-col cols="12">
            <v-textarea v-model="transaction.comments" label="Observații" class="ma-1" outlined dense hide-details/>
          </v-col>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Facturi asociate</div>
          </v-col>

          <v-col cols="12">
            <im-transaction-invoices :invoices="transaction.invoices" :all="invoices"/>
          </v-col>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Fișiere</div>
          </v-col>
          <v-col cols="12">
            <v-file-input v-model="files" accept="application/pdf" label="Adăuga" class="ma-1" @change="onFileChange($event)" multiple small-chips show-size outlined dense hide-details/>
          </v-col>
          <v-col cols="12" v-for="(file, index) in files_64" :key="`file64_${index}`">
            <v-card class="ma-1" outlined>
              <v-card-text class="pa-1">
                <v-row no-gutters align="center">
                  <v-col cols="11">
                    <v-text-field v-model="file.name" label="Nume" class="ma-1" outlined dense hide-details/>
                  </v-col>
                  <v-col cols="1">
                    <div class="ma-1">
                      <v-btn height="40" color="delete white--text" depressed block @click="removeFile(file)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" v-for="(file, index) in transaction.files" :key="`file_${index}`">
            <v-card class="ma-1" outlined>
              <v-card-text class="pa-1">
                <v-row no-gutters align="center">
                  <v-col cols="10">
                    <v-text-field v-model="file.properties.name" label="Nume" class="ma-1" outlined dense hide-details readonly/>
                  </v-col>
                  <v-col cols="1">
                    <div class="ma-1">
                      <v-btn height="40" color="primary" :href="file.url" target="_blank" dark depressed block>
                        <v-icon>
                          mdi-download
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col cols="1">
                    <div class="ma-1">
                      <v-btn height="40" color="delete white--text" depressed block @click="destroyFile(file, index)" :loading="file_loading[index]" :disabled="file_loading[index]">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

        </v-row>
      </v-card-text>

    </v-card>

    <v-card outlined v-resize="onResize" :width="dynamic_width" class="ma-2" :style="{position: 'fixed', bottom: 0, maxWidth: '960px'}">
      <v-card-actions>
        <v-btn v-if="transaction.id" depressed color="delete white--text" @click="destroy" :loading="deleting" :disabled="deleting">
          <v-icon left>mdi-delete</v-icon>
          Șterge
        </v-btn>
        <v-spacer/>
        <v-btn depressed color="primary white--text" @click="save" :loading="saving" :disabled="saving">
          <v-icon left>mdi-floppy</v-icon>
          Salvează
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import transaction_repository from '@/repositories/transaction-repository'
  import invoice_repository from '@/repositories/invoice-repository'
  import config_repository from '@/repositories/config-repository'
  import media_repository from "@/repositories/media-repository";

  export default {

    components: {
      'im-transaction-invoices': () => import('@/components/Transaction/TransactionInvoiceList'),
    },

    data: () => ({
      transaction: null,
      transaction_types: null,
      transaction_methods: null,
      invoices: null,
      currencies: null,

      menu_date: false,

      files: null,
      files_64: null,
      file_loading: [],

      saving: false,
      deleting: false,

      dynamic_width: 0
    }),

    async created() {
      transaction_repository.getTransaction(this.$route.params.transaction).then(r => this.transaction = r);
      config_repository.getTransactionTypes().then(r => this.transaction_types = r );
      config_repository.getTransactionMethods().then(r => this.transaction_methods = r);
      config_repository.getCurrencies().then(r => this.currencies = r);
      invoice_repository.getInvoices(null, {page: 1, size: Number.MAX_SAFE_INTEGER}, {dropdown: true}).then(r => this.invoices = r);
    },

    methods: {

      async save() {
        try {

          this.saving = true;

          this.transaction = await transaction_repository.saveTransaction(this.transaction);
          await media_repository.saveMedia(this.transaction.id, 'transactions', {files: this.files_64});
          await this.$store.dispatch('alert/success', 'Tranzacția a fost salvată.');

          if (this.$route.params.transaction === 'create')
            await this.$router.push(`/transactions/${this.transaction.id}`);

          this.transaction = await transaction_repository.getTransaction(this.transaction.id);

        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.saving = false;
          this.files = null;
          this.files_64 = null;
        }
      },

      async destroy() {
        try {
          this.deleting = true;
          await transaction_repository.destroyTransaction(this.transaction);
          await this.$router.push(`/transactions`);
          await this.$store.dispatch('alert/success', 'Tranzacția a fost ștearsă.');
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.deleting = false;
        }
      },

      async destroyFile(file, index) {
        try {
          this.$set(this.file_loading, index, true);
          await media_repository.deleteFile(this.$route.params.transaction, 'transactions', file);
          this.transaction = await transaction_repository.getTransaction(this.transaction.id);
          await this.$store.dispatch('alert/success', 'Documentul a fost sters!');
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.$set(this.file_loading, index, false);
        }
      },

      removeFile(file) {
        this.files.splice(this.files.indexOf(file), 1);
        this.files_64.splice(this.files_64.indexOf(file), 1);
      },

      onResize() {
        this.dynamic_width = this.$refs['parent'].clientWidth - 40;
      },

      onFileChange(files) {
        this.files_64 = [];
        for (let file of files) {
          const fileReader = new FileReader();
          fileReader.addEventListener('load', () => {
            this.files_64.push({
              data: fileReader.result,
              name: file.name
            });
          });
          fileReader.readAsDataURL(file);
        }
      },

    }


  }

</script>